import { List } from 'immutable';
import { AsyncState, loadingAsyncState } from 'widgets-for-react';
import { Link } from '../../../cms/blocks/types.gen';
import { linkWrapper } from '../../../cms/blocks/utils.gen';
import { WordPress } from '../../../wordpress/wordpress_api';
import { LinkContainer, Selector } from './regionSwitchState.mod';

export const getRegionSwitchData = (): AsyncState<List<Selector>> => {

    return loadingAsyncState(async () => {
        try {
            const data = await WordPress.findMenuByLocation('directory');
            const result = _mapData(data);
            
            return {
                kind: 'result',
                status: 200,
                value: result
            }
        } catch (e) {
            return {
                kind: 'failed',
                status: 500
            }
        }
    })
}

const _mapData = (data): List<Selector> => {
    if(data != null && data.data != null){
        const result: Selector[] = data.data.map(d => {
            if(d['title'] != null ){
                return {
                    title: d['title'] ? d['title'] : "",
                    linkContainer: d['child_items'] ? _mapLinkContainer(d['child_items']) : [],
                    links: d['child_items'] ? _mapLinks(d['child_items']) : []
                }
            }
        })
        return List(result);
    }else {
        return List();
    }
    
}

const _mapLinkContainer = (data): List<LinkContainer> => {
    if(data != null){
        const count = data.length;
        let childFound = false;
        const containers: LinkContainer[] =  data.map(d => {
            if(d['child_items']){
                childFound = true;
            }

            if(d['title']){
                return {
                    title: d['title'] ?  d['title'] : '',
                    links: d['child_items'] ? _mapLinks(d['child_items']) : []
                } 
            }
        });

        if(childFound && count == containers.length){
            return List(containers);
        }else {
            return List();
        }
        
    }else {
        return List();
    }
}

const _mapLinks = (data): List<Link> => {
    if(data){
        const count = data.length;
        let childFound = false;
        const results: Link[] = data.map(item => {
            if(item['child_items'] != null){
                childFound = true;
            } 
            if(item['child_items'] == null && item['title'] && item['url']){
                return linkWrapper(item);
            }
        });

        if(!childFound && count == results.length){
            return List(results);
        }else {
            return List();
        }
    }else {
        return List();
    }
}

